import React from "react";
import classnames from "classnames";
import { useDrag } from "react-dnd";

import ItemTypes from "../ItemTypes";

export default function({ employee, onClick, selected }) {
  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.EMPLOYEE, selected, idDragged: employee.id },
    collect: mon => ({
      isDragging: !!mon.isDragging()
    })
  });

  return (
    <div
      ref={drag}
      onClick={onClick}
      className={classnames("EmployeeListItem clickable", {
        selected: selected[employee.id],
        dragging: isDragging
      })}
    >
      {employee.name}
    </div>
  );
}
